import { palette, Text } from 'main/ui'
import { stars } from 'main/util/networkRating'
import React from 'react'

export default function NetworkRating(props: {
  networkRating: number | null
  size?: number | null
}) {
  const { networkRating, size } = props
  return (
    <Text css={{ color: palette.mediumGray, fontSize: `${size || 14}px` }}>
      {networkRating != null && networkRating >= 1 && (
        <span>
          {'Paths to QUALITY\u2122 Level'} {networkRating} {stars(networkRating)}
        </span>
      )}
    </Text>
  )
}
